import React from 'react';
import { cn } from '@/utils';

export default function MainNav({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'sticky top-0 flex w-full items-end bg-brand-25 bg-brand-light-75 px-8 dark:border-x-brand-dark-20 dark:bg-brand-dark-75 dark:text-brand-light-25',
        className,
      )}
    >
      {children}
      <div className="absolute right-0 top-0 z-10 h-full w-10 bg-gradient-to-r from-transparent to-brand-25 dark:to-brand-dark-75"></div>
    </div>
  );
}
